import React, { useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import AutoSuggestionsdata from '../Movie/Autosuggestionsdata'
import Dragdrop from '../Movie/Dragdrop'
import GetFormattedData from '../Movie/GetFormattedData'
import AwsConfig from '../../Config/AwsConfig'

const PersonInputsuggest = props => {
  // state variable for this file
  const [ProductionCompneyNames, setpersonInputnames] = useState([])
  const {
    inputData,
    sendinputdata,
    name,
    inputField1,
    inputField2,
    // truevalue,
    disableInput,
  } = props
  const [personInputname, setpersonInputname] = useState('')
  const [personInputnameTelugu, setpersonInputnameTelugu] = useState('')
  const [filteredPersonNames, setFilteredPersonNames] = useState([])
  const [filteredPersonNamesTelugu, setFilteredPersonNamesTelugu] = useState([])
  const [searchBoolean, setsearchBoolean] = useState(true)
  const [autoSuggestions, setAutoSuggestions] = useState([])
  const [editMode, seteditMode] = useState(true)
  const sendEditmode = data => {
    seteditMode(data)
  }
  // on change in input tag this function is trigered and state variable of personInputname is changed

  const PersonNameEnglish = event => {
    setsearchBoolean(true)
    setpersonInputname(event.target.value)
  }

  const sendsearchBoolean = data => {
    setsearchBoolean(data)
  }

  // on change in input tag this function is trigered and state variable of personInputname is changed
  // for telugu field
  const PersonNameTelugu = event => {
    setpersonInputnameTelugu(event.target.value)
  }

  // this function recives data from child component
  const sendpersonInputname = data => {
    setpersonInputname(data)
  }

  const sendpersonInputnameTelugu = data => {
    setpersonInputnameTelugu(data)
  }

  // sending values to inputobject in parent
  const senddata = async (valueOne, valueTwo) => {
    const dataFeilds = { valueOne, valueTwo }
    const field = [inputField1, inputField2]
    const formattedData = await GetFormattedData(inputData, dataFeilds, field)
    sendinputdata(formattedData)
  }

  // function to send new values to parent after clicking ok button
  const Submitperson = () => {
    seteditMode(true)
    props.sendtruevalue(`${name}_En`, true)
    const inputDataEnglishTemp = [...inputData[inputField1]]

    const personInputname1 = personInputname
    inputDataEnglishTemp.push(personInputname1)
    const inputDataTeluguTemp = [...inputData[inputField2]]
    const personInputnameTelugu1 = personInputnameTelugu
    if (personInputnameTelugu1.length === 0) {
      const ProductionCompneyfield = `(${personInputname})*`

      inputDataTeluguTemp.push(ProductionCompneyfield)
      senddata(inputDataEnglishTemp, inputDataTeluguTemp)
    } else {
      inputDataTeluguTemp.push(personInputnameTelugu1)
      senddata(inputDataEnglishTemp, inputDataTeluguTemp)
    }

    setpersonInputname('')
    setFilteredPersonNames([])
    setpersonInputnameTelugu('')
    setsearchBoolean(true)
  }

  // function after clicking on suggested values
  const PersonNameSelection = index => {
    // regex checks for if create is needed
    // const regex = /Create [A-Za-z]+/i
    props.sendtruevalue(`${name}_En`, true)
    if (index === 0) {
      setsearchBoolean(false)
    } else {
      const inputDataEnglishTemp = [...inputData[inputField1]]
      inputDataEnglishTemp.push(filteredPersonNames[index - 1].label)

      const indextel = filteredPersonNames.findIndex(obj => obj.label === filteredPersonNames[index - 1].label)
      const inputDataTeluguTemp = [...inputData[inputField2]]

      inputDataTeluguTemp.push(
        filteredPersonNamesTelugu[indextel].label
          ? filteredPersonNamesTelugu[indextel].label
          : `(${filteredPersonNames[index - 1].label})*`,
      )
      const personInputnames1 = [...ProductionCompneyNames]
      personInputnames1.push({
        label: filteredPersonNames[index - 1].label,
        labelte: filteredPersonNamesTelugu[indextel].label
          ? filteredPersonNamesTelugu[indextel].label
          : `(${filteredPersonNames[index - 1].label})*`,
      })

      setpersonInputnames(personInputnames1)
      senddata(inputDataEnglishTemp, inputDataTeluguTemp)
      setpersonInputname('')
      setpersonInputnameTelugu('')
      setFilteredPersonNames([])
    }
  }

  // in this function autosuggestion service is called only when value lenght is graterthan or equal to 3
  const handlepersonInputnamechange = async value => {
    setpersonInputname(value)
    if (value.length <= 3) {
      setFilteredPersonNames([])
    }

    if (value.length >= 3) {
      try {
        const personNameSuggestions = await AutoSuggestionsdata(value)

        setAutoSuggestions(personNameSuggestions)

        const filteredPersonNames = autoSuggestions
          ? personNameSuggestions.personHits.map(e => ({ label: e.name_En, personID: e.personID ? e.personID : e.PK, ...e }))
          : []
        const filteredPersonNamesTelugu = autoSuggestions
          ? personNameSuggestions.personHits.map(e => ({ label: e.name_Te, personID: e.personID ? e.personID : e.PK, ...e }))
          : []

        setFilteredPersonNames(filteredPersonNames)
        setFilteredPersonNamesTelugu(filteredPersonNamesTelugu)
      } catch (err) {
        console.warn(err)
        setAutoSuggestions([])
      }
    }
  }

  // in the below code create of a person is added to display with autosuggested values
  const finalfilteredPersonNames = [...filteredPersonNames]
  if (personInputname.length >= 3) {
    finalfilteredPersonNames.unshift({ label: `Create ${personInputname}` })
  }

  return (
    <div>
      <Row>
        <Col md={6} xs={12}>
          <div>
            <label>{`${name}_En`}:</label>
            {inputData[inputField1].length >= 1 && (
              <div>
                {/* display of english names,edit,delete,draganddrop in below component */}
                <Dragdrop
                  name={name}
                  truevalue={props.truevalue}
                  sendtruevalue={props.sendtruevalue}
                  display={inputData[inputField1]}
                  displayte={inputData[inputField2]}
                  namearr={personInputname}
                  namearrtel={personInputnameTelugu}
                  sendname={sendpersonInputname}
                  sendnamete={sendpersonInputnameTelugu}
                  // nameenglish={sendPersonNameEnglishg}
                  // nametelugu={sendPersonNameTelugulugu}
                  senddata={senddata}
                  sendsearchtrue={sendsearchBoolean}
                  personnames={ProductionCompneyNames}
                  editpersonmode={editMode}
                  sendPersonEditmode={sendEditmode}
                />
              </div>
            )}
            {searchBoolean && (
              <input
                type={'text'}
                className='form-control'
                // onchange handlePersonInputnamechange gets triggred
                onChange={e => handlepersonInputnamechange(e.target.value)}
                value={personInputname}
                disabled={disableInput === true}
              ></input>
            )}
            {/* suggestion are shown using below */}
            {finalfilteredPersonNames.length >= 1 && searchBoolean && (
              // <div className='searchfield'>
              //   {searchBoolean &&
              //     finalfilteredPersonNames.map((personInputname, ProductionCompneyIndex) => (
              //       <div key={ProductionCompneyIndex} onClick={event => PersonNameSelection(event)}>
              //         {/*   onclick PersonInputset is trigred on the label clicked */}
              //         <label>{personInputname.label}</label>
              //       </div>
              //     ))}
              // </div>
              <div className='searchfield' style={{ width: '200%',
              position: 'relative',
              zIndex: '1',
              }}>
                  {searchBoolean && finalfilteredPersonNames.map((personInputname, personIndex) => {
              let { posterURL } = personInputname
              if (posterURL && !posterURL.includes(AwsConfig.movieCdnUrl)) {
                posterURL = AwsConfig.movieCdnUrl + posterURL
              }

              return (
                <div
                  key={personIndex}
                  onClick={() => PersonNameSelection(personIndex)}
                  style={{
                    width: '100%',
                    marginRight: '10px',
                  }}
                >
                  <ul className='list-group list-group-flush'>
                    <li className='list-group-item' style={{ marginRight: 'auto' }}>
                      <div className='media d-flex justify-content-center align-items-center'>
                        {personInputname && personInputname.label && personInputname.label.includes('Create') ? '' : <img
                          style={{ width: '2rem', height: '2rem' }}
                          className='mr-3 align-self-center'
                          src={posterURL}
                        />}
                        <div className='media-body align-self-center' style={{ display: 'flex', flexWrap: 'wrap', fontSize: '10px' }}>
                          {personIndex === 0 ? <label>{personInputname.label}</label> :
                          <div>
                            <span><b>Name:</b>{personInputname.label}{`(${personInputname.roles ? personInputname.roles.toString() : ''})`}</span><br/>
                            <span>{personInputname.personWikiURL}</span>
                          </div>}
                        </div>
                      </div>
                          <hr style={{ background: 'black', color: 'black' }}/>
                    </li>
                  </ul>
                </div>
              )
            })}
              </div>
            )}
            {/* if searchBoolean is false onchange PersonInputEnglish gets trigred */}
            {!searchBoolean && (
              <input
                className='form-control'
                value={personInputname}
                style={{ width: '100%' }}
                onChange={event => PersonNameEnglish(event)}
                disabled={disableInput === true}
              />
            )}
          </div>
        </Col>
        {/* if searchBoolean is false or inputData[inputFiled2] is not empty then the following is displayed */}
        {(!searchBoolean || (inputData[inputField2] && inputData[inputField2].length >= 1)) && (
          <Col md={6} xs={12}>
            <div>
              <label>{`${name}_Te`}:</label>
              <div>
                {/* display of telugu names */}
                {inputData[inputField2] && inputData[inputField2].length >= 1 && (
                  <div
                    style={{ display: 'flex', flexWrap: 'wrap', border: '1px solid lightgray' }}
                    className='rounded'
                  >
                    {inputData[inputField2].map((e, index) => (
                      <span
                        style={{
                          margin: '5px',
                          border: '1px solid black',
                          padding: '1px',
                          borderRadius: '1rem',
                        }}
                        key={index}
                      >
                        {e}
                      </span>
                    ))}
                  </div>
                )}
              </div>
              {/* input for telugu when manually entered */}
              {!searchBoolean && (
                <input
                  type='text'
                  className='form-control'
                  value={personInputnameTelugu}
                  style={{ width: '100%' }}
                  disabled={disableInput === true}
                  onChange={event => PersonNameTelugu(event)}
                />
              )}
            </div>
            {/* button for sending manually added english and telugu names to parent */}
            {!searchBoolean && (
              <button
                style={{ float: 'right' }}
                disabled={!(personInputname.length >= 1) && disableInput === true}
                type='button'
                onClick={() => Submitperson()}
                className='btn btn-primary'
              >
                ok
              </button>
            )}
          </Col>
        )}
      </Row>
    </div>
  )
}

export default PersonInputsuggest
